var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _line, _line2, _line3, _line4, _line5, _line6, _line7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyDocumentsLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 58,
    viewBox: "0 0 63 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 22.5,
    width: 38,
    height: 21,
    fill: "#C5B165",
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 17.5,
    width: 21,
    height: 24,
    fill: "#D9D9D9",
    stroke: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 19.5,
    width: 21,
    height: 22,
    fill: "#D9D9D9",
    stroke: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 24.5,
    width: 38,
    height: 19,
    fill: "#C5B165",
    stroke: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 20.5,
    width: 2,
    height: 1,
    fill: "#C5B165",
    stroke: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 21,
    width: 2,
    height: 2,
    fill: "#C5B165"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 21.5,
    x2: 28,
    y2: 21.5,
    stroke: "black"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 29,
    y1: 21.5,
    x2: 32,
    y2: 21.5,
    stroke: "black"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 21.5,
    x2: 34,
    y2: 21.5,
    stroke: "black"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 21.5,
    x2: 40,
    y2: 21.5,
    stroke: "black"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 19.5,
    x2: 16,
    y2: 19.5,
    stroke: "black"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 19.5,
    x2: 19,
    y2: 19.5,
    stroke: "black"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 21.5,
    x2: 19,
    y2: 21.5,
    stroke: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyDocumentsLogo);
export default __webpack_public_path__ + "static/media/myDocuments-logo.3171cb2c8b713c4e62a38ad1e2185f5d.svg";
export { ForwardRef as ReactComponent };